<div class="rows gap-3 d-flex flex-column">
  @for (row of rowsArr; track row) {
    <div class="row">
      @for (col of colsArr; track col) {
        <x-ghost-product-card [class]="'col'"></x-ghost-product-card>
      }
    </div>
  }
</div>
